var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.61 6a15.61 15.61 0 0 1 10.07 27.56l-9.62 9a.74.74 0 0 1-1.02 0l-9.47-9A15.61 15.61 0 0 1 23.61 6Zm-3.11 6.99c-.83 0-1.5.67-1.5 1.5v14a1.5 1.5 0 1 0 3 0V24h2.5a5.5 5.5 0 0 0 0-11h-3.83l-.17-.01Zm4 3.01a2.5 2.5 0 1 1 0 5H22v-5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPMarker);
export default __webpack_public_path__ + "static/media/p-marker.03969ca3.svg";
export { ForwardRef as ReactComponent };